@if (isAllowed) {
	<div>
		@if (documentObj.patient_id) {
			<div class="d-flex justify-content-between">
				<div class="colstat-big">
					<label class="inline">{{ "document_templates" | langVal }}</label>
					<app-gen-select
						tabindex="0"
						[actualObj]="documentObj"
						[errors]="errors"
						fieldName="document_template"
						hasNone
						(changeEvent)="handleTemplateChange()"
						title_ph_lang="document_templates"
						[options]="documenttemplates"
						[hasPlus]="permsService?.perms?.administrative"
						plusLang="add"
						(plusClick)="modalProps = { name: 'add-document-teamplte' }"
					/>
				</div>
				<div class="colstat-small">
					<label>{{ "language" | langVal }}</label>
					<app-gen-select
						[actualObj]="documentObj"
						[errors]="errors"
						fieldName="lang"
						(changeEvent)="handleLangChange()"
						optionsListName="langOpts"
						optionFieldId="value"
					/>
				</div>
			</div>
		}

		<div class="d-flex justify-content-between mb-2 flex-wrap gap-4">
			<!--@if(!permsService?.owner_has_users){-->
			<div>
				<label class="inline">{{ "headtures" | langVal }}</label>
				<app-gen-select
					class="colstat-big"
					tabindex="0"
					[actualObj]="documentObj"
					[errors]="errors"
					avoidLang
					fieldName="headture_id"
					title_ph_lang="headtures"
					[options]="headtures"
					(changeEvent)="validateEntireForm()"
					[hasPlus]="permsService?.perms?.administrative"
					plusLang="add"
					(plusClick)="modalProps = { name: 'add-headture' }"
				/>
			</div>
			<!--}-->

			<div>
				<label>&nbsp;</label>
				<app-gen-button-group
					[actualObj]="documentObj"
					fieldName="medical_conf"
					optionsListName="medicalConf_opts"
				></app-gen-button-group>
			</div>

			<div class="colstat-small mis-auto">
				<label>{{ "date" | langVal }}</label>
				<app-date-picker
					#datePicker
					[actualObj]="documentObj"
					[errors]="errors"
					fieldName="date"
					tabindex="1"
					[addonObject]="{ after: { icon: 'calendar' } }"
				>
				</app-date-picker>
			</div>
		</div>

		<div class="colstat-big">
			<label class="inline">{{ "recipient" | langVal }}</label>
			<div>
				<app-gen-autocomplete
					#contactFuzzyInput
					[fuzzySearchableClasses]="['contacts']"
					[actualObj]="documentObj"
					fieldName="recipient"
					[error]="errors.recipient"
					tabindex="1"
					(chosenEvent)="handleContactChange($event)"
					(keyUp)="handleContactKeyUp($event)"
					[hasPlus]="permsService?.perms?.administrative"
					[plusLang]="('add' | langVal) + ' ' + ('contact' | langVal)"
					(plusClick)="openAddContactModal()"
				/>
			</div>
		</div>
		<div class="colstat-big">
			<label>{{ "address" | langVal }}</label>
			<app-gen-input
				[actualObj]="documentObj"
				[errors]="errors"
				tabindex="0"
				fieldName="address"
				(keyupEvent)="validateEntireForm()"
			/>
		</div>

		<div class="d-flex align-items-end gap-1 w-50 mx-auto">
			<app-check
				[isCheck]="documentObj.show_title === 'yes'"
				(onClick)="flipShowTitle()"
			/>
			<div class="colstat-big-double">
				<label>{{ "title" | langVal }}</label>
				<app-gen-input
					#titleInput
					className="titleClass"
					[actualObj]="documentObj"
					[errors]="errors"
					fieldName="title"
					tabindex="2"
					(keyupEvent)="validateEntireForm()"
				/>
			</div>
		</div>
	</div>
	<div>
		<div>
			<label class="inline">{{ "html_content" | langVal }}</label>
			<app-wysiwyg
				#htmlContent
				isAddDocument
				[actualObj]="documentObj"
				[errors]="errors"
				fieldName="html_content"
				exHtmlStyle="line-height:200%;"
				[initHeight]="200"
				tabindex="3"
				(changeEvent)="validateEntireForm()"
			/>
		</div>
		@if (followupImages?.length) {
			<div>
				<label>{{ "add_image_to_document" | langVal }}</label>
				<div class="image-container">
					@for (image of followupImages; track image.id) {
						<div (click)="checkImage(image)">
							<div>
								<app-yes-no
									[isCheck]="image.isChecked"
									(onClick)="checkImage(image)"
								/>
							</div>
							<img [src]="image.id | serverImg: 'followup-image'" />
						</div>
					}
				</div>
			</div>
		}
	</div>

	<div class="my-2">
		<label class="control-label">{{ "remarks" | langVal }}</label>
		<app-ta-expands
			tabindex="0"
			[actualObj]="documentObj"
			[errors]="errors"
			fieldName="remarks"
		/>
	</div>

	<div class="modal-btns">
		<app-cancel-btn (click)="onClose.emit()" />
		<app-btn-ext
			[disabled]="!isFormSubmittable"
			(clickEv)="openPreview()"
			text="to_preview"
			tabindex="5"
		/>
	</div>
}
@if (isDefaultSigOpen) {
	<app-require-default-signature
		(onDone)="isDefaultSigOpen = false; $event ? init() : onClose.emit()"
	/>
}

@switch (modalProps?.name) {
	@case ("preview-finresource") {
		<app-preview-finresource
			(onClose)="modalProps = null; closeIfValue($event)"
			[headtureRow]="modalProps.headtureRow"
			[finresourceObj]="modalProps.finresourceObj"
			doctype="document"
			[isEn]="documentObj.lang === 'en'"
		/>
	}
	@case ("add-document-teamplte") {
		<app-modal-wrap
			(onClose)="modalProps = null; loadDocumentTemplates()"
			title="documenttemplates"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; loadDocumentTemplates()"
				tableName="documenttemplates"
			/>
		</app-modal-wrap>
	}
	@case ("add-contact") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contacts"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; $event && handleCloseAddcontact($event)"
				tableName="contacts"
				[fuzzyName]="modalProps.fuzzyName"
			/>
		</app-modal-wrap>
	}
	@case ("add-headture") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="headtures"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; handleAddHeadtureClose($event)"
				tableName="headtures"
				filterField="header_default"
				filterFieldValue="l"
				[filterFieldApiObject]="{
					lang: documentObj.lang,
				}"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-replace-text") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="retrieve_text"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="
					$event && htmlContent.replaceText(modalProps.state); modalProps = null
				"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-no-headtures") {
		<app-modal-wrap
			(onClose)="onClose.emit()"
			title="no_letter_header_yet"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm (onClose)="onClose.emit()" />
		</app-modal-wrap>
	}
}
